<template>
  <div
    class="poiret"
    style="background-color: black;"
  >
    <b-container class="p-5">
      <div style="width: 100%; text-align: center;">
        <a href="http://ach.com.hk">
          <img
            style="width: 300px; height: 70px; cursor: pointer;"
            :src="laravel_url + 'assets/images/ach-hk-logo-v2.png'"
          >
        </a>
      </div>
      <br>
      <div style="width: 100%; text-align: center;">
        <p class="white-text">
          Follow / Contact Us:
        </p>
      </div>
      <b-row>
        <b-col
          cols="12"
          style="text-align: center;"
        >
          <a href="https://www.facebook.com/art.ch.773776"><i class="fa fa-facebook-square fa-2x text-white" /></a>
          &emsp;
          <a href="https://www.instagram.com/artcollection_hk/"><i class="fa fa-instagram fa-2x text-white" /></a>
          &emsp;
          <a href="https://twitter.com/ArtCollectionHK"><i class="fa fa-twitter fa-2x text-white" /></a>
          &emsp;
          <a href="https://www.youtube.com/channel/UC5v4ij-0YX5sOVCY9Nu0bHQ"><i class="fa fa-youtube fa-2x text-white" /></a>
        </b-col>
      </b-row>
      <br>
      <div style="width: 100%; text-align: center;">
        <p class="white-text">
          &#169;&nbsp;Copyrighted Art Collection House Online Shop {{ year }}
        </p>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'OrFooter',
  data: function () {
    let date = new Date()
    return {
      year: date.getFullYear(),
      laravel_url: window.LARAVEL_URL
    }
  }
}
</script>

<style scoped>
.poiret {
  font-family: 'Poiret One';
  font-size: large;
}
.white-text {
    color: white;
}
i {
    cursor: pointer;
}
</style>
